module.exports = __webpack_public_path__ + "img/logo-white.6881ad9.png";